var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonati(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "217px",
    height: "47px",
    viewBox: "0 0 217 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Donati_Logo_Red_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.071147541 0.36895 216.504339 0.36895 216.504339 47 0.071147541 47"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donati---Home",
    transform: "translate(-260.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donati_Logo_Red_White",
    transform: "translate(260.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E42E33",
    mask: "url(#mask-2)",
    points: "51.8013388 47 216.504339 47 216.504339 0.370125 51.8013388 0.370125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#E42E33",
    mask: "url(#mask-2)",
    points: "0.071147541 46.99765 47.0581694 46.99765 47.0581694 0.36895 0.071147541 0.36895"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5986419,33.5662995 C83.9566527,33.5662995 85.9224446,31.3227374 85.9224446,28.3313213 C85.9224446,25.2211422 84.1926887,22.9764042 81.5986419,22.9764042 C78.8460635,22.9764042 77.3112427,25.3375534 77.3112427,28.0561674 C77.3112427,31.3227374 78.9235679,33.5662995 81.5986419,33.5662995 Z M93,38.5272998 L86.4743694,38.5272998 L86.4743694,34.8656371 L86.3945165,34.8656371 C85.4902992,37.1491788 82.62029,39 79.3568876,39 C73.2634024,39 70,33.9613922 70,27.8974248 C70,22.8576412 73.1048708,17.5427037 78.7662106,17.5427037 C81.5986419,17.5427037 83.9965792,18.2905578 85.8050138,20.6528828 L85.8836924,20.6528828 L85.8836924,9 L93,9 L93,38.5272998 Z",
    id: "Fill-5",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.635221,27.5195638 C112.635221,24.5147961 111.28789,21.854121 107.999409,21.854121 C104.71211,21.854121 103.365962,24.5147961 103.365962,27.5195638 C103.365962,30.4863547 104.71211,33.1447282 107.999409,33.1447282 C111.28789,33.1447282 112.635221,30.4863547 112.635221,27.5195638 Z M96,27.5195638 C96,20.8529154 101.187047,17 107.999409,17 C114.812953,17 120,20.8529154 120,27.5195638 C120,34.1470846 114.812953,38 107.999409,38 C101.187047,38 96,34.1470846 96,27.5195638 Z",
    id: "Fill-6",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,17.4742239 L129.501857,17.4742239 L129.501857,21.2562479 L129.579992,21.2562479 C131.007749,18.3002914 133.862078,17 137.110639,17 C142.739977,17 145,20.9397064 145,25.1959543 L145,38 L137.864769,38 L137.864769,28.0718929 C137.864769,24.2098509 136.516332,22.9095596 134.573589,22.9095596 C131.641124,22.9095596 130.136415,24.9194217 130.136415,29.3321753 L130.136415,38 L123,38 L123,17.4742239",
    id: "Fill-7",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.571654,33.3760412 C160.259843,33.3760412 161.96063,30.9869575 161.96063,28.6358505 C161.051181,28.5978737 160.023622,28.5219202 158.954724,28.5219202 C156.542913,28.5219202 154.643701,29.2515344 154.643701,31.1802937 C154.643701,32.567021 155.909843,33.3760412 157.571654,33.3760412 Z M162.474409,37.537374 C162.435433,36.4579132 162.317323,35.41758 162.317323,34.3795484 L162.237008,34.3795484 C160.616535,36.8825625 158.638189,38 155.71378,38 C151.638976,38 148,36.0332639 148,31.6820473 C148,25.5539785 154.842126,24.8220627 158.638189,24.8220627 C159.78622,24.8220627 161.051181,24.9382946 161.96063,25.0925033 C161.921654,22.3558746 159.825197,21.6239588 157.255118,21.6239588 C154.960236,21.6239588 152.668898,22.0486081 150.690551,23.126918 L150.570079,18.4258549 C153.102362,17.4246493 155.751575,17 158.797638,17 C164.057087,17 168.604331,19.1968983 168.604331,25.3238163 L168.604331,32.7994849 C168.604331,34.3795484 168.683465,35.9573104 169,37.537374 L162.474409,37.537374 Z",
    id: "Fill-8",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,17.831554 L174.332687,17.831554 L174.332687,13.1826809 L181.565224,11 L181.565224,17.831554 L186.713188,17.831554 L186.713188,22.8351127 L181.565224,22.8351127 L181.565224,30.460261 C181.565224,32.9620403 182.177902,34.2336892 184.50779,34.2336892 C185.243736,34.2336892 186.018738,34.0747331 186.754684,33.9561091 L187,38.6014235 C185.611099,38.7615658 184.220978,39 182.381722,39 C175.80336,39 174.209419,36.1779359 174.209419,31.2550415 L174.209419,22.8351127 L170,22.8351127 L170,17.831554",
    id: "Fill-9",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,38 L197,38 L197,17.5278239 L190,17.5278239 L190,38 Z M190,14.1864098 L197,14.1864098 L197,9 L190,9 L190,14.1864098 Z",
    id: "Fill-10",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#FFFFFE",
    points: "19 39 30.473388 9 42 39 19 39"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#FFFFFE",
    points: "28 9 16.5260085 39 5 9 28 9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonati);
export default __webpack_public_path__ + "static/media/donati.f0e03eb4cb46bcd9170f563ee0477346.svg";
export { ForwardRef as ReactComponent };